import axios from 'axios';

// Configure axios with timeout and error handling
const api = axios.create({
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.warn('API Error:', error.message);
    // Return a resolved promise with fallback data instead of throwing
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.warn('API timeout - using fallback data');
      return Promise.resolve({ data: { fallback: true } });
    }
    if (error.response?.status >= 500) {
      console.warn('Server error - using fallback data');
      return Promise.resolve({ data: { fallback: true } });
    }
    return Promise.reject(error);
  }
);

export function get(url) {  
  return api.get(url).catch(error => {
    console.warn(`Failed to fetch ${url}:`, error.message);
    // Return fallback response instead of throwing
    return { data: { fallback: true, error: error.message } };
  });
}
